<template>
  <div>
    <div class="menu  pos-rel m-t-20">
      <div 
      v-for="(flow, index) in flows" 
      class="flow-menu"
      :class="{'flow-menu-selected': flow.selected}"
      @click="selectFlow(index)">
        <div 
        class='icon-flow' 
        :class="flow.selected ? 'active-icon-' + flow.title : 'icon-' + flow.title">
        </div>
        <span>{{flow.name}}</span>
      </div>
      <div class='arrow' :style='{left: (114 + 238 * curFlowIndex ) + "px"}'></div>
    </div>
    <div class="flow-cate bg-wh pos-rel p-l-10">
      <ul class="m-t-20 p-t-30 p-b-10 m-r-110 p-r-10 m-b-0 p-l-0">
        <li 
        class="cate" 
        :class='{"cate-selected": all}' 
        v-if= 'curFlowTit == "addFlow"' 
        @click="selectCate(-1, -1)">
        全部
        </li>
        <li 
        class="cate" 
        :class='{"cate-selected": common}' 
        v-if= 'curFlowTit == "addFlow"' 
        @click="selectCate(0, 0)">
        常用流程
        </li>
        <li 
        class="cate" 
        :class='{"cate-selected": common}' 
        v-else 
        @click="selectCate(0, 0)">
        全部
        </li>
        <li 
        v-for="(cate, index) in cates" 
        class="cate" 
        :class='{"cate-selected": cateId == cate.id}' 
        @click="selectCate(cate.id, index+1)">
        {{cate.name}}
        </li>
        <div style="clear:both"></div>
      </ul>
      <div class='flod'>
        <div class='searchTip' @click='searchContShow'>
          <span v-if='searchShow'>收起搜索</span>
          <span v-else>展开搜索</span> 
        </div>
        <div class="jiantou" :class='{"jiantouUp": searchShow, "jiantouDown": !searchShow}'></div>
      </div>
    </div>
    <div class='bg-wh searchCont' :class='{"hidden": !searchShow}' style='padding-left: 54px;'>
      <div class="fl w-300 p-l-10" v-if='curFlowTit == "addFlow"' @keyup.enter="search()">
        <input v-model="curKeywords" placeholder="输入流程名称搜索" class="p-l-20 h-30" />
      </div>
      <div v-else class="fl w-300" @keyup.enter="search()">
        <input v-model="curKeywords" placeholder="输入主题/申请人/编号 搜索" class="p-l-20 h-30" />
      </div>
      <div class="fl m-l-10 p-l-10" v-if='curFlowTit != "addFlow"'>
        <daterange-filter v-model="curTimeRange" :placeholder="placeholder"></daterange-filter>
      </div>
      <div class="fl m-l-20 p-l-10">
        <el-button type="primary" @click="search">搜索</el-button>
      </div>
      <div style="clear:both"></div>
    </div>
  </div>
</template>
<style scoped>
  .topMenTemplate{
    transition: all 0.5s;
    -moz-transition: all 0.5s; /* Firefox 4 */
    -webkit-transition: all 0.5s; /* Safari 和 Chrome */
    -o-transition: all 0.5s; /* Opera */
    position: fixed;
    top: 40px;
    z-index: 99;
    overflow: hidden;
    height: 0px;
  }
  .topMenu{
    background: #f3f3f2;
    transition: all 0.5s;
    -moz-transition: all 0.5s; /* Firefox 4 */
    -webkit-transition: all 0.5s; /* Safari 和 Chrome */
    -o-transition: all 0.5s; /* Opera */
  }
  .arrow{
    position: absolute;
    left: 119px;
    border: 10px solid transparent;
    width: 0;
    height: 0px;
    border-bottom: 11px solid #fff;
    bottom: -20px;
  }
  .searchCont{
    overflow: hidden;
    height: 60px;
    transition: all 0.5s;
    -moz-transition: all 0.5s; /* Firefox 4 */
    -webkit-transition: all 0.5s; /* Safari 和 Chrome */
    -o-transition: all 0.5s; /* Opera */
  }
  .hidden {
    height: 0px;
  }
  .jiantou{
    position: absolute;
    right: 34px;
    border: 5px solid transparent;
    width: 0;
    height: 0px;
  }
  .jiantouUp{
    border-bottom: 5px solid #98A6B3;
    top: 23px;
  }
  .jiantouDown{
    border-top: 5px solid #98A6B3;
    top: 28px;
  }
  .searchTip {
    position: absolute;
    top: 20px;
    right: 60px;
    font-size: 14px;
    color: #999;
  }
  .cate-selected {
    font-weight: bold !important;
    color: #20a0ff !important;
  }
  .icon-data:before {
    content: "";
  }
  .icon-flow{
    height: 30px;
    width: 30px;
    display: inline-block;
    margin-right: 10px;
    vertical-align: middle;
  }
  .menu{
    width: 1190px;
    height: 100px;
    /*margin-top:20px;*/
  }
  .flow-menu{
    float: left;
    width: 237px;
    height: 100px;
    line-height: 100px;
    text-align: center;
    color: #333;
    border-left: 1px solid #f1f2f7;
    font-size: 18px;
    font-weight: bold;
    background: #fff;
  }
  .flow-menu-selected{
    color: #fff;
    background: #20a0ff;
  }
  .cate {
    float: left;
    color: #333;
    line-height: 19px;
    font-size: 14px;
    margin-left: 54px;
    margin-bottom: 10px;
  }
  input{
    outline:none;
    width: 280px;
    border: 1px solid #cecece;
  }
  input:focus {
    border: 1px solid #20a0ff;
  }
</style>
<script>
  import daterangeFilter from '../../Common/business/filter/daterangeFilter'
  export default {
    name: 'topMenu',
    data() {
      return {
        searchShow: false,
        curTimeRange: [],
        curKeywords: '',
        placeholder: '请选择创建时间范围'
      }
    },
    props: {
      flows: {
        type: Array,
        default() {
          return []
        }
      },
      curFlowIndex: {
        type: Number,
        default() {
          return 0
        }
      },
      cateId: {
        type: Number,
        default() {
          return 0
        }
      },
      curFlowTit: {
        type: String,
        default() {
          return ''
        }
      },
      common: {
        type: Boolean,
        default() {
          return false
        }
      },
      all: {
        type: Boolean,
        default() {
          return true
        }
      },
      cates: {
        type: Array,
        default() {
          return []
        }
      },
      keywords: {
        type: String,
        default() {
          return ''
        }
      },
      timeRange: {
        type: Array,
        default() {
          return []
        }
      }
    },
    methods: {
      search() {
        // console.log(this.timeRange)
        this.$emit('search', { keywords: this.curKeywords, timeRange: this.curTimeRange })
      },
      selectFlow(index) {
        this.$emit('selectFlow', index)
      },
      selectCate(cateId, index) { // 选择类别
        // let tabTitle = document.getElementsByClassName('tabTitle')
        // tabTitle[index].scrollIntoView()
        // console.log(index)
        this.$emit('selectCate', { typeId: cateId, index: index })
      },
      searchContShow() {
        this.searchShow = !this.searchShow
      },
      inputfocus() {
        console.log('触发了')
      }
    },
    created() {
      // this.path = this.$route.path
      // this.getFlowCates()
    },
    components: {
      daterangeFilter
    },
    watch: {
      keywords() {
        this.curKeywords = this.keywords
      },
      timeRange() {
        this.curTimeRange = this.timeRange
      }
    }
  }
</script>
<style>
</style>


// WEBPACK FOOTER //
// topMenu.vue?5fd3fff9